import { BlockOutlined, CheckOutlined } from "@ant-design/icons";
import { Flex, Modal, Button } from "antd";
import React from "react";
import { useState } from "react";
import { useTranslation } from "react-i18next";

interface NormalModalProps {
  children?: React.ReactElement<{ onClose?: () => void }>;
  title: React.ReactNode;
  icon?: React.ReactNode;
  open?: boolean;
  onCancel?: () => void;
  footer?: React.ReactNode;
  trigger?: React.ReactNode;
  width?: number;
  destroyOnClose?: boolean;
  style?: React.CSSProperties;
  styles?: React.ComponentProps<typeof Modal>["styles"];
}

export const NormalModal = ({
  children,
  title,
  icon,
  open,
  onCancel,
  footer,
  trigger,
  width = 450,
  destroyOnClose = false,
  style,
  styles,
}: NormalModalProps) => {
  const [internalOpen, setInternalOpen] = useState(false);
  const { t } = useTranslation();

  const isControlled = open !== undefined;
  const modalOpen = isControlled ? open : internalOpen;

  const showModal = () => {
    if (!isControlled) {
      setInternalOpen(true);
    }
  };

  const handleCancel = () => {
    if (!isControlled) {
      setInternalOpen(false);
    }
    onCancel?.();
  };

  return (
    <>
      {!isControlled && (
        <div onClick={showModal}>
          {trigger || (
            <Button type="primary">
              {t("open")} {title}
            </Button>
          )}
        </div>
      )}

      <Modal
        destroyOnClose={destroyOnClose}
        title={
          <Flex gap={6} align="center">
            {icon ?? <BlockOutlined />}
            {title ?? t("button.add.operator")}
          </Flex>
        }
        okButtonProps={{
          icon: <CheckOutlined />,
          iconPosition: "end",
        }}
        okText={t("save")}
        open={modalOpen}
        onCancel={handleCancel}
        footer={footer}
        width={width}
        style={style}
        styles={styles}
      >
        {children && React.isValidElement(children)
          ? React.cloneElement(children as React.ReactElement, {
            onClose: handleCancel,
          })
          : children}
      </Modal>
    </>
  );
};
